export default __webpack_public_path__ + "static/media/trylleby-property-18.0cf4b4ff.jpg";